import { defineLocale } from "../../registry";

const terms = defineLocale({
  ru: {
    "terms.title": "Партнёр и условия",
    "terms.unavailable": "Условия для этого Pick недоступны",
    "terms.dealStatus": "Статус сделки",
    "terms.affiliation.legend": "Партнёрские отношения",
    "terms.affiliation.commission": "Комиссия",
    "terms.affiliation.leadFee": "Плата за лиды",
    "terms.affiliation.freeServices": "Бесплатные услуги",
    "terms.affiliation.paidPlacement": "Платное размещение",
    "terms.disclosure.label": "Требуется раскрытие",
    "terms.disclosure.yes": "Да",
    "terms.disclosure.no": "Нет",
    "terms.disclosure.hint": "Считается автоматически по партнёрским отношениям",
    "terms.rate": "Ставка",
    "terms.notes": "Заметки",
    "terms.contacts.legend": "Контакты",
    "terms.contacts.name": "Контакт {n}: имя",
    "terms.contacts.channel": "Контакт {n}: канал связи",
    "terms.contacts.add": "Добавить контакт",
    "terms.contacts.remove": "Удалить контакт {n}",
    "terms.contacts.empty": "Контактов пока нет",
    "terms.contacts.limit": "Достигнут предел: {max} контактов",
    "terms.warning.editorial":
      "Предупреждение: сделка «только редакционный» не должна включать комиссию, плату за лиды или платное размещение.",
    "terms.issue.generic":
      "Сервер отклонил условия. Проверьте отмеченные поля.",
    "terms.issue.editorial_only_with_affiliation":
      "Сделка «только редакционный» не может включать комиссию, плату за лиды или платное размещение",
    "terms.issue.deal_status_invalid": "Выберите допустимый статус сделки",
    "terms.issue.contacts_too_many": "Слишком много контактов",
    "terms.issue.contact_empty": "У каждого контакта должны быть имя и канал связи",
    "terms.issue.contact_name_too_long": "Имя контакта слишком длинное",
    "terms.issue.contact_channel_too_long": "Канал связи контакта слишком длинный",
    "terms.issue.rate_too_long": "Ставка слишком длинная",
    "terms.issue.notes_too_long": "Заметки слишком длинные",
    "terms.issue.text_invalid": "Текст содержит недопустимые символы",
    "terms.issue.partner_required":
      "Сначала выберите партнёра на вкладке «Ссылки»: ставка, заметки и контакты привязаны к партнёру",
    "terms.compliance.title": "Compliance",
    "terms.compliance.status": "Статус compliance",
    "terms.compliance.status.pending": "На проверке",
    "terms.compliance.status.cleared": "Одобрено",
    "terms.compliance.status.blocked": "Заблокировано",
    "terms.compliance.status.unknown": "Неизвестный статус compliance",
    "terms.compliance.note": "Примечание к compliance",
    "terms.compliance.save": "Сохранить compliance",
    "terms.compliance.noteHint":
      "Чтобы сохранить изменение compliance, нужно примечание",
    "terms.compliance.issue.compliance_invalid":
      "Выберите допустимый статус compliance",
    "terms.compliance.issue.note_invalid":
      "Примечание содержит недопустимые символы",
    "terms.compliance.issue.generic": "Сервер отклонил изменение compliance",
  },
  en: {
    "terms.title": "Partner & terms",
    "terms.unavailable": "Terms are not available for this Pick",
    "terms.dealStatus": "Deal status",
    "terms.affiliation.legend": "Affiliation",
    "terms.affiliation.commission": "Commission",
    "terms.affiliation.leadFee": "Lead fee",
    "terms.affiliation.freeServices": "Free services",
    "terms.affiliation.paidPlacement": "Paid placement",
    "terms.disclosure.label": "Disclosure required",
    "terms.disclosure.yes": "Yes",
    "terms.disclosure.no": "No",
    "terms.disclosure.hint": "Calculated from the affiliation flags",
    "terms.rate": "Rate",
    "terms.notes": "Notes",
    "terms.contacts.legend": "Contacts",
    "terms.contacts.name": "Contact {n} name",
    "terms.contacts.channel": "Contact {n} channel",
    "terms.contacts.add": "Add contact",
    "terms.contacts.remove": "Remove contact {n}",
    "terms.contacts.empty": "No contacts yet",
    "terms.contacts.limit": "Limit reached: {max} contacts",
    "terms.warning.editorial":
      "Warning: an editorial-only deal should not include commission, lead fee or paid placement.",
    "terms.issue.generic":
      "The server rejected the terms. Check the highlighted fields.",
    "terms.issue.editorial_only_with_affiliation":
      "An editorial-only deal cannot include commission, lead fee or paid placement",
    "terms.issue.deal_status_invalid": "Choose a valid deal status",
    "terms.issue.contacts_too_many": "There are too many contacts",
    "terms.issue.contact_empty":
      "Every contact needs both a name and a channel",
    "terms.issue.contact_name_too_long": "A contact name is too long",
    "terms.issue.contact_channel_too_long": "A contact channel is too long",
    "terms.issue.rate_too_long": "The rate is too long",
    "terms.issue.notes_too_long": "The notes are too long",
    "terms.issue.text_invalid": "The text contains characters that are not allowed",
    "terms.issue.partner_required":
      "Choose a partner on the Links tab first: rate, notes and contacts belong to a partner",
    "terms.compliance.title": "Compliance",
    "terms.compliance.status": "Compliance status",
    "terms.compliance.status.pending": "Pending",
    "terms.compliance.status.cleared": "Cleared",
    "terms.compliance.status.blocked": "Blocked",
    "terms.compliance.status.unknown": "Unknown compliance status",
    "terms.compliance.note": "Compliance note",
    "terms.compliance.save": "Save compliance",
    "terms.compliance.noteHint":
      "A note is required to save a compliance change",
    "terms.compliance.issue.compliance_invalid":
      "Choose a valid compliance status",
    "terms.compliance.issue.note_invalid":
      "The note contains characters that are not allowed",
    "terms.compliance.issue.generic":
      "The server rejected the compliance change",
  },
});

export default terms;
